var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82102 22.1786C8.03537 22.393 8.24956 22.5 8.57111 22.5C8.89248 22.5 9.10683 22.3928 9.32119 22.1786L14.9998 16.5L20.6785 22.1786C20.8928 22.393 21.2142 22.5 21.4285 22.5C21.6429 22.5 21.9643 22.3928 22.1786 22.1786C22.6072 21.7501 22.6072 21.1072 22.1786 20.6786L16.5 15L22.1786 9.32138C22.6072 8.89284 22.6072 8.24994 22.1786 7.8214C21.7501 7.39287 21.1072 7.39287 20.6786 7.8214L15 13.5L9.32138 7.8214C8.89284 7.39287 8.24994 7.39287 7.8214 7.8214C7.39287 8.24994 7.39287 8.89284 7.8214 9.32138L13.5 15L7.8214 20.6786C7.39287 21.1073 7.39287 21.7501 7.8214 22.1788L7.82102 22.1786Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhite);
export default __webpack_public_path__ + "static/media/CloseIconWhite.403a7da86405ce17fd93742e4be8745a.svg";
export { ForwardRef as ReactComponent };